import React from 'react';

const OptimaImportModal = ({
  optimaPreview, optimaOptions, setOptimaOptions,
  warehouses, isSaving, onSave, onClose
}) => {
  if (!optimaPreview) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
      alignItems: 'center', justifyContent: 'center', zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'var(--card-bg)', borderRadius: '8px', width: '95%', maxWidth: '1200px',
        maxHeight: '90vh', display: 'flex', flexDirection: 'column', overflow: 'hidden'
      }}>
        {/* Header */}
        <div style={{
          padding: '1rem', borderBottom: '1px solid var(--border)',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          background: 'linear-gradient(135deg, var(--success), var(--success))'
        }}>
          <div style={{ color: '#fff' }}>
            <h5 style={{ margin: 0, fontSize: '16px' }}>{'📦'} Import magazynu Optima</h5>
            <div style={{ fontSize: '12px', opacity: 0.9 }}>
              Plik: {optimaPreview.filename} | {optimaPreview.stats?.total || 0} pozycji
            </div>
          </div>
          <button onClick={onClose}
            style={{ background: 'var(--bg-secondary)',  color: 'var(--text)' ,
              fontSize: '20px', cursor: 'pointer', padding: '4px 10px' }}>{'×'}</button>
        </div>

        {/* Stats & Options */}
        <div style={{ padding: '1rem', borderBottom: '1px solid var(--border)', display: 'flex', gap: '2rem', flexWrap: 'wrap', backgroundColor: 'var(--bg)' }}>
          <div style={{ display: 'flex', gap: '1rem' }}>
            <div style={{ textAlign: 'center', padding: '0.5rem 1rem', backgroundColor: 'var(--success-light)', borderRadius: '4px' }}>
              <div style={{ fontSize: '20px', fontWeight: '700', color: 'var(--success)' }}>{optimaPreview.stats?.found || 0}</div>
              <div style={{ fontSize: '10px', color: 'var(--success)' }}>Znaleziono</div>
            </div>
            <div style={{ textAlign: 'center', padding: '0.5rem 1rem', backgroundColor: 'var(--warning-light)', borderRadius: '4px' }}>
              <div style={{ fontSize: '20px', fontWeight: '700', color: 'var(--warning)' }}>{optimaPreview.stats?.not_found || 0}</div>
              <div style={{ fontSize: '10px', color: 'var(--warning)' }}>Nie znaleziono</div>
            </div>
          </div>

          <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', flexWrap: 'wrap' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '12px', cursor: 'pointer' }}>
              <input type="checkbox" checked={optimaOptions.update_prices}
                onChange={e => setOptimaOptions(prev => ({ ...prev, update_prices: e.target.checked }))} />
              {'💰'} Aktualizuj ceny zakupu
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '12px', cursor: 'pointer' }}>
              <input type="checkbox" checked={optimaOptions.update_stock}
                onChange={e => setOptimaOptions(prev => ({ ...prev, update_stock: e.target.checked }))} />
              {'📦'} Aktualizuj stany magazynowe
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '12px', cursor: 'pointer' }}>
              <input type="checkbox" checked={optimaOptions.create_missing}
                onChange={e => setOptimaOptions(prev => ({ ...prev, create_missing: e.target.checked }))} />
              {'➕'} Dodaj brakuj{'ą'}ce produkty
            </label>
            {optimaOptions.update_stock && (
              <select value={optimaOptions.warehouse_id || ''}
                onChange={e => setOptimaOptions(prev => ({ ...prev, warehouse_id: e.target.value }))}
                style={{ padding: '6px 10px', fontSize: '12px', borderRadius: '6px', border: '1px solid var(--border)', backgroundColor: 'var(--card-bg)', color: 'var(--text)' }}>
                <option value="">-- Wybierz magazyn --</option>
                {warehouses.map(w => (
                  <option key={w.id} value={w.location_id}>{w.nazwa}</option>
                ))}
              </select>
            )}
          </div>
        </div>

        {/* Product list */}
        <div style={{ flex: 1, overflow: 'auto', padding: '0.5rem' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11px' }}>
            <thead style={{ position: 'sticky', top: 0, backgroundColor: 'var(--bg)' }}>
              <tr>
                <th style={{ padding: '0.5rem', textAlign: 'left', borderBottom: '2px solid var(--border)' }}>Status</th>
                <th style={{ padding: '0.5rem', textAlign: 'left', borderBottom: '2px solid var(--border)' }}>Kod</th>
                <th style={{ padding: '0.5rem', textAlign: 'left', borderBottom: '2px solid var(--border)' }}>Nazwa (Optima)</th>
                <th style={{ padding: '0.5rem', textAlign: 'left', borderBottom: '2px solid var(--border)' }}>W systemie</th>
                <th style={{ padding: '0.5rem', textAlign: 'right', borderBottom: '2px solid var(--border)' }}>Ilo{'ść'}</th>
                <th style={{ padding: '0.5rem', textAlign: 'right', borderBottom: '2px solid var(--border)' }}>Cena zak.</th>
                <th style={{ padding: '0.5rem', textAlign: 'right', borderBottom: '2px solid var(--border)' }}>VAT</th>
              </tr>
            </thead>
            <tbody>
              {optimaPreview.products?.slice(0, 100).map((p, idx) => (
                <tr key={idx} style={{
                  backgroundColor: (p.is_found || p.found) ? (idx % 2 === 0 ? 'var(--card-bg)' : 'var(--bg)') : 'var(--warning-light)'
                }}>
                  <td style={{ padding: '0.4rem 0.5rem', borderBottom: '1px solid var(--border)' }}>
                    {(p.is_found || p.found) ? '✅' : '⚠️'}
                  </td>
                  <td style={{ padding: '0.4rem 0.5rem', borderBottom: '1px solid var(--border)', fontFamily: 'monospace' }}>
                    {p.kod || p.ean}
                  </td>
                  <td style={{
                    padding: '0.4rem 0.5rem', borderBottom: '1px solid var(--border)',
                    maxWidth: '250px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
                  }}>
                    {p.nazwa}
                  </td>
                  <td style={{ padding: '0.4rem 0.5rem', borderBottom: '1px solid var(--border)', maxWidth: '300px' }}>
                    <span style={{
                      color: (p.is_found || p.found) ? 'var(--success)' : 'var(--danger)',
                      overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block'
                    }}>
                      {p.existing_name || p.product_name || '-'}
                    </span>
                  </td>
                  <td style={{ padding: '0.4rem 0.5rem', borderBottom: '1px solid var(--border)', textAlign: 'right', fontWeight: '600' }}>
                    {p.ilosc}
                  </td>
                  <td style={{ padding: '0.4rem 0.5rem', borderBottom: '1px solid var(--border)', textAlign: 'right', fontWeight: '600', color: 'var(--success)' }}>
                    {(p.cena_netto || p.cena_zakupu || 0).toFixed(2)} z{'ł'}
                  </td>
                  <td style={{ padding: '0.4rem 0.5rem', borderBottom: '1px solid var(--border)', textAlign: 'right' }}>
                    {p.vat || p.stawka_vat || 23}%
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {optimaPreview.products?.length > 100 && (
            <div style={{ padding: '1rem', textAlign: 'center', color: 'var(--text-muted)', fontSize: '11px' }}>
              ... i {optimaPreview.products.length - 100} wi{'ę'}cej produkt{'ó'}w
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{ padding: '1rem', borderTop: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: 'var(--bg)' }}>
          <div style={{ fontSize: '11px', color: 'var(--text-muted)' }}>
            {optimaOptions.update_stock && !optimaOptions.warehouse_id && (
              <span style={{ color: 'var(--danger)' }}>{'⚠️'} Wybierz magazyn aby zaktualizowa{'ć'} stany</span>
            )}
          </div>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <button onClick={onClose}
              style={{ padding: '6px 12px', fontSize: '12px', border: '1px solid var(--border)',
                backgroundColor: 'var(--card-bg)', color: 'var(--text-secondary)', cursor: 'pointer' }}>
              Anuluj
            </button>
            <button onClick={onSave}
              disabled={isSaving || (!optimaPreview.stats?.found && !optimaPreview.stats?.will_create) || (optimaOptions.update_stock && !optimaOptions.warehouse_id)}
              style={{
                padding: '6px 12px', fontSize: '12px',
                backgroundColor: (isSaving || (!optimaPreview.stats?.found && !optimaPreview.stats?.will_create) || (optimaOptions.update_stock && !optimaOptions.warehouse_id)) ? 'var(--border)' : 'var(--success)',
                color: '#fff' , cursor: 'pointer', fontWeight: '600'
              }}>
              {isSaving ? '⏳ Zapisywanie...' : `✅ Zapisz zmiany (${(optimaPreview.stats?.found || 0) + (optimaPreview.stats?.will_create || 0)} produktów)`}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OptimaImportModal;
